import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../../api";

export default function PaymentResultPage() {

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [message, setMessage] = useState("در حال بررسی پرداخت...");

  useEffect(() => {

  const authority = searchParams.get("Authority");
  const status = searchParams.get("Status");

  if (!authority || !status) {
    setMessage("اطلاعات پرداخت نامعتبر است.");
    setTimeout(() => navigate("/cart"), 3000);
    return;
  }

  const verifyPayment = async () => {
    try {

      const res = await api.get(
        `/operation/payments/zarinpal/callback/?Authority=${authority}&Status=${status}`
      );

      if (res.data.status === "payment_success") {
        setMessage("✅ پرداخت با موفقیت انجام شد.");
        setTimeout(() => navigate("/customer-panel/order/"), 3000);

      } else if (res.data.status === "payment_cancelled") {
        setMessage("❌ پرداخت توسط کاربر لغو شد.");
        setTimeout(() => navigate("/cart"), 3000);

      } else {
        setMessage("❌ پرداخت ناموفق بود.");
        setTimeout(() => navigate("/cart"), 3000);
      }

    } catch (err) {
      setMessage("خطا در بررسی پرداخت.");
      setTimeout(() => navigate("/cart"), 3000);
    }
  };

  verifyPayment();

}, []);


  return (
    <div className="flex items-center justify-center min-h-screen">
      <h2 className="text-xl font-bold">{message}</h2>
    </div>
  );
}
